import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  // mode: 'history', // TODO: Remove # from links but we can't use img at least in local dev env (by placing them in public folder)
  routes: [
    {
      path: "/",
      name: "login-page",
      component: require("@/components/LoginPage").default,
    },
    {
      path: "/home",
      name: "home-page",
      component: require("@/components/HomePage").default,
    },
    {
      path: "/project",
      name: "project-page",
      component: require("@/components/ProjectPage").default,
    },
    {
      path: "/project/1",
      name: "creation-page",
      component: require("@/components/CreationPage").default,
    },
    {
      path: "/fast-project",
      name: "fast-creation-page",
      component: require("@/components/FastCreationPage").default,
    },
    {
      path: "/mediacenter",
      name: "mediacenter-page",
      component: require("@/components/MediacenterPage").default,
    },
    {
      path: "/schedule",
      name: "schedule-page",
      component: require("@/components/SchedulePage").default,
    },
    {
      path: "/status/:playerId?",
      name: "status-page",
      props: true,
      component: require("@/components/StatusPage").default,
    },
    {
      path: "/profile/:sectionInitial?",
      name: "profile-page",
      props: true,
      component: require("@/components/ProfilePage").default,
    },
    {
      path: "/stats",
      name: "stats-page",
      component: require("@/components/StatsPage").default,
    },
    {
      path: "/help",
      name: "help-page",
      component: require("@/components/HelpPage").default,
    },
    {
      path: "/settings",
      name: "settings-page",
      component: require("@/components/SettingsPage").default,
    },
    {
      path: "/test",
      name: "test-page",
      component: require("@/components/TestPage").default,
    },
    {
      path: "/player",
      name: "player-page",
      component: require("@/components/PlayerPage").default,
    },
    {
      path: "/preview/:license?",
      name: "preview-page",
      props: true,
      component: require("@/components/PreviewPage").default,
    },
    {
      path: "/viewer",
      name: "viewer-page",
      component: require("@/components/ViewerPage").default,
    },
    {
      path: "/changelog",
      name: "changelog-page",
      component: require("@/components/ChangelogPage").default,
    },
    {
      path: "/minato",
      name: "minato-page",
      component: require("@/components/MikitoPage/MinatoPage").default,
    },
    {
      path: "/akito",
      name: "akito-page",
      component: require("@/components/MikitoPage/AkitoPage").default,
    },
    {
      path: "/kirito",
      name: "kirito-page",
      component: require("@/components/MikitoPage/KiritoPage").default,
    },
    {
      path: "/kirua",
      name: "kirua-page",
      component: require("@/components/MikitoPage/KiruaPage").default,
    },
    {
      path: "/susano",
      name: "susano-page",
      component: require("@/components/MikitoPage/SusanoPage").default,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
